import { render, staticRenderFns } from "./authDetail.vue?vue&type=template&id=a40cef80&scoped=true"
import script from "./authDetail.vue?vue&type=script&lang=js"
export * from "./authDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40cef80",
  null
  
)

export default component.exports